import React from 'react';
import {connect} from "react-redux";
import {
    recreateSchematicsTabs,
} from "../../../store/Schematic_store/actions";
import {Pagination} from "antd";
import styles from './GraphPagination.module.css';
import {
    PlusOutlined,
    MinusOutlined
} from '@ant-design/icons';

class GraphPagination extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onMount(this);
    }

    /**
     * is for parent to refresh the component
     */
    refresh = () => {
        this.forceUpdate();
    }

    render() {
        const {graph: {model},removePage,addPage,switchPage} = this.props;
        return (
            <div className={styles.paginationWrapper}>
                <Pagination size="small" total={model.pages.length} current={model.activePage + 1} pageSize={1}
                            onChange={switchPage}/>
                <div>
                    <PlusOutlined style={{
                        fontSize: '17px',
                        cursor: 'pointer',
                        marginRight: '5px'
                    }} onClick={addPage}/>
                    {model.pages.length > 1 &&
                    <MinusOutlined style={{
                        fontSize: '17px',
                        cursor: 'pointer'
                    }} onClick={removePage}/>}
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({schematicReducers: {graph, schematicDocument}}) => {
    return {
        schematicDocument,
        graph: graph.value
    }
}

function mapDispatchToProps(dispatch) {
    return {
        recreateSchematicsTabs: (elements) => {
            dispatch(recreateSchematicsTabs(elements))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GraphPagination);
